import React, { Component } from 'react';

// import auth from './Auth';
import { router } from "../routes";

export default class Callback extends Component {

  async componentDidMount() {
    // await auth.handleAuthentication();
    router.navigate({ name: 'Home' });
  }

  render() {
    const style = {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
    }

    return (
      <div style={style}>
        {/*<img src={loading} alt="loading"/>*/}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/auth/callback.js